/**
 * this matches strings of the format YYYY/MM/DD where YYYY is 19XX 20XX or 21XX,
 * MM is a valid month number and DD is a valid date number
 **/
export const isValueYYYYMMDD = (maybeDate) => {
    const dateRegex = /^(19|20|21)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/;
    return dateRegex.test(maybeDate);
};
//# sourceMappingURL=isValueYYYYMMDD.js.map